import { useTransactionCertificateStore } from "../../../../store/transaction-certificates.store";

interface FarmTraderOrganicInformation {
    inputFarmTraderOrganicInformationOrder: string;
    inputFarmScNo: string;
    inputFarmTcNo: string;
    inputTraderTcNoForOrganicMaterial: string;
    inputTcOrganicFarmStandards: string;
}

interface TcProductStandardInformation {
    inputTcProductStandardInformationOrder: string;
    inputTcProductStandardLabelGrade: string;
    inputTcProductCertifiedWeight: string;
    inputTcProductCertifiedWeightUsed: string;
}

interface ProductRawMaterialInformation {
    inputProductRawMaterialInformationOrder: string;
    inputTcProductRawMaterialCode: string;
    inputTcProductRawMaterialPercentage: string;
}

interface CertifiedRawMaterialWeightUsedInformation {
    inputTcCertifiedRawMaterialCode: string;
    outputTcCertifiedRawMaterialCode: string;
    inputTcCertifiedRawMaterialWeightUsed: number;
    inputTcCertifiedRawMaterialCodeDescription?: string;
    outputTcCertifiedRawMaterialCodeDescription?: string;
}

interface TcProductInformation {
    inputTcProductInformationOrder: string;
    inputTcProductNo: string;
    inputTcProductArticleNo: string;
    inputTcProductNumberOfUnits: string;
    inputTcProductUnitsMetric: string;
    inputTcProductProductionDate: string;
    inputTcProductCategoryCode: string;
    inputTcProductCategoryUserSpecificTerm: string;
    inputTcProductDetailCode: string;
    inputTcProductDetailUserSpecificTerm: string;
    inputTcProductInfoTrimsExcluded: string;
    inputTcProductInfoAssociatedTc: string;
    inputTcProductInfoFiberLength: string;
    inputTcProductInfoYarnCount: string;
    inputTcProductInfoFabricWeightAndConstruct: string;
    inputTcProductInfoFabricWeightOfFinishedProduct: string;
    inputTcProductInfoAdditional: string;
    inputTcProductStandardInformation: TcProductStandardInformation[];
    inputProductRawMaterialInformation: ProductRawMaterialInformation[];
}

interface InputTcInformation {
    inputTcOrder: string;
    inputTcNo: string;
    inputTcCbLicensingCode: string;
    inputTcSellerLicenseNo: string;
    inputTcSellerTeId: string;
    inputTcSellerScNo: string;
    inputTcUsdaCompliantFlag: string;
    inputTcCertifiedWeightUsed: string;
    inputTcCertifiedRawMaterialWeightUsedInformation: CertifiedRawMaterialWeightUsedInformation[];
    inputFarmTraderOrganicInformation: FarmTraderOrganicInformation[];
    inputTcProductInformation: TcProductInformation[];
}

interface TransformedPayload {
    tcId: string;
    inputTcInformation: InputTcInformation[];
}
// Instead of 'any[]', accept an object
  
export const mapPayload = (data: any, tcId: any, inputTcId?: any) => {
    console.log("map", data);
  
    return {
      tcId: tcId,
      ...(inputTcId ? { inputTcId } : {}),
  
      inputTcInformation: [
        {
          inputTcOrder: "1",
          inputTcNo:
            data.ocsProcessorConfig &&
            data.ocsProcessorConfig.tableData &&
            data.ocsProcessorConfig.tableData.length > 0
              ? "N/A"
              : data.inputTcDetails.inputTcNo,
          tcAssociatedProductNo: data.inputTcDetails.tcAssociatedProductNo, // Corrected typo here too
          inputTcCbLicensingCode: data.inputTcDetails.InputCBLicensingCode || "",
          inputTcSellerLicenseNo: data.inputTcDetails.inputTcSellerLicenseNo,
          inputTcSellerTeId: data.inputTcDetails.inputTcSellerTeId,
          inputTcSellerScNo: data.inputTcDetails.inputTcSellerScNo,
          inputTcUsdaCompliantFlag: data.inputTcDetails.inputTcUsdaCompliantFlag,
          inputTcCertifiedRawMaterialWeightUsedInformation:
            data.inputTcDetails.inputTcCertifiedWeightUsed?.map((item: any) => ({
              inputTcCertifiedRawMaterialCode: item.inputTcCertifiedRawMaterialCode || "",
              outputTcCertifiedRawMaterialCode: item.outputTcCertifiedRawMaterialCode || "",
              inputTcCertifiedRawMaterialWeightUsed: item.inputTcCertifiedRawMaterialWeightUsed || 0,
              inputTcCertifiedRawMaterialCodeDescription: item.inputTcCertifiedRawMaterialCodeDescription || "",
              outputTcCertifiedRawMaterialCodeDescription: item.outputTcCertifiedRawMaterialCodeDescription || "",
            })) || [],
          ocsProcessor: data.ocsProcessorConfig.inputTcOCSFirstProcessor || "",
          inputFarmTraderOrganicInformation:
            data.ocsProcessorConfig.tableData.map(
              (proc: {
                inputFarmSCNo: any;
                inputFarmTCNo: any;
                inputTraderTCNoForOrganicMaterial: any;
                inputTCOrganicFarmStandards: any;
                tcProductRawMaterialOrder: number;
              }, idx: number) => ({
                inputFarmTraderOrganicInformationOrder: (idx + 1).toString(),
                inputFarmScNo: proc.inputFarmSCNo,
                inputFarmTcNo: proc.inputFarmTCNo,
                inputTraderTcNoForOrganicMaterial:
                  proc.inputTraderTCNoForOrganicMaterial,
                inputTcOrganicFarmStandards: proc.inputTCOrganicFarmStandards,
              })
            ),
          inputTcProductInformation: [
            {
              inputTcProductInformationOrder: "1",
              inputTcProductNo: data.inputTcProductDetails.inputTcProductNo,
              inputTcProductArticleNo:
                data.inputTcProductDetails.inputTcProductArticleNo,
              inputTcProductNumberOfUnits:
                parseFloat(data?.inputTcProductDetails?.inputTcProductNumberOfUnits),
              inputTcProductUnitsMetric:
                data.inputTcProductDetails.inputTcProductUnitsMetric || "",
              inputTcProductProductionDate:
                data.inputTcProductDetails.inputTcProductProductionDate,
              inputTcProductCategoryCode:
                data.inputTcProductDetails.inputTcProductCategoryCode,
              inputTcProductCategoryCodeDescription: useTransactionCertificateStore.getState().getProductCategoriesStore.find((option: any) => option.value === data.inputTcProductDetails.inputTcProductCategoryCode)?.label || "",
              inputTcProductCategoryUserSpecificTerm:
                data.inputTcProductDetails.inputTcProductCategoryUserSpecificTerm,
              inputTcProductDetailCode:
                data.inputTcProductDetails.inputTcProductDetailCode,
              inputTcProductDetailCodeDescription: useTransactionCertificateStore.getState().getProductDetailCodeStore.find((option: any) => option.value === data.inputTcProductDetails.inputTcProductDetailCode)?.label || "",
              inputTcProductDetailUserSpecificTerm:
                data.inputTcProductDetails.inputTcProductDetailUserSpecificTerm,
              inputTcProductInfoTrimsExcluded:
                data.inputTcProductAdditionalDetails.inputTcProductInfoTrimsExcluded,
              inputTcProductInfoAssociatedTc:
                data.inputTcProductAdditionalDetails.inputTcProductInfoAssociatedTc,
              inputTcProductInfoFiberLength:
                data.inputTcProductAdditionalDetails.inputTcProductInfoFiberLength ||
                "",
              inputTcProductInfoYarnCount:
                data.inputTcProductAdditionalDetails.inputTcProductInfoYarnCount ||
                "",
              inputTcProductInfoFabricWeightAndConstruct:
                data.inputTcProductAdditionalDetails
                  .inputTcProductInfoFabricWeightAndConstruct || "",
              inputTcProductInfoFabricWeightOfFinishedProduct:
                data.inputTcProductAdditionalDetails
                  .inputTcProductInfoFabricWeightOfFinishedProduct || "",
              inputTcProductInfoAdditional:
                data.inputTcProductAdditionalDetails.inputTcProductInfoAdditional,
              inputTcProductStandardInformation:
                data.inputTcProductStandardDetails.map(
                  (
                    stdInfo: {
                      standardLabelGrade: any;
                      certifiedWeight: string;
                      certifiedWeightUsed: string;
                    },
                    idx: number
                  ) => ({
                    inputTcProductStandardInformationOrder: (idx + 1).toString(),
                    inputTcProductStandardLabelGrade:
                      stdInfo.standardLabelGrade || "",
                    inputTcProductStandardLabelGradeDescription: useTransactionCertificateStore.getState().getLabelGrades.find((option: any) => option.value === stdInfo.standardLabelGrade)?.label || "",
                    inputTcProductCertifiedWeight: (stdInfo.certifiedWeight && stdInfo.certifiedWeight!=="")?
                    parseFloat(stdInfo.certifiedWeight) :null,
                    inputTcProductCertifiedWeightUsed: (stdInfo.certifiedWeightUsed && stdInfo.certifiedWeightUsed!=="")?
                    parseFloat(stdInfo.certifiedWeightUsed) :null,
                  })
                ),
              inputProductRawMaterialInformation: data.rawMaterialDetails.map(
                (rawMaterial: {
                  tcProductRawMaterialOrder: { toString: () => any };
                  tcProductRawMaterialCode: any;
                  tcProductRawMaterialPercentage: string;
                }) => ({
                  inputProductRawMaterialInformationOrder:
                    rawMaterial.tcProductRawMaterialOrder.toString(),
                  inputTcProductRawMaterialCode:
                    rawMaterial.tcProductRawMaterialCode,
                  inputTcProductRawMaterialCodeDescription: useTransactionCertificateStore.getState().getRawMtrlCodes.find((option: any) => option.value === rawMaterial.tcProductRawMaterialCode)?.label || "",
                  inputTcProductRawMaterialPercentage: parseFloat(
                    rawMaterial.tcProductRawMaterialPercentage
                  ),
                })
              ),
            },
          ],
        },
      ],
    };
  };
  
export const reverseMapPayload = (payload: any) => {
    const { tcId, inputTcInformation } = payload;

    const data = inputTcInformation.map((inputItem: any) => ({
        tcProductComponentOrder: inputItem.inputTcOrder,
        inputTcNo: inputItem.inputTcNo,
        tcAssociatedProdcutNo: inputItem.tcAssociatedProductNo,
        inputTcSellerLicenseNo: inputItem.inputTcSellerLicenseNo,
        inputTcSellerTeId: inputItem.inputTcSellerTeId,
        InputCBLicensingCode: inputItem.inputTcCbLicensingCode,
        inputTcSellerScNo: inputItem.inputTcSellerScNo,
        inputTcUsdaCompliantFlag: inputItem.inputTcUsdaCompliantFlag,
        inputTcCertifiedWeightUsed: inputItem.inputTcCertifiedRawMaterialWeightUsedInformation?.map((item: any) => ({
          inputTcCertifiedRawMaterialCode: item.inputTcCertifiedRawMaterialCode || "",
          outputTcCertifiedRawMaterialCode: item.outputTcCertifiedRawMaterialCode || "",
          inputTcCertifiedRawMaterialWeightUsed: item.inputTcCertifiedRawMaterialWeightUsed || 0,
          inputTcCertifiedRawMaterialCodeDescription: item.inputTcCertifiedRawMaterialCodeDescription || "",
          outputTcCertifiedRawMaterialCodeDescription: item.outputTcCertifiedRawMaterialCodeDescription || "",
        })) || [],
        "input-tc-ocs-processor": inputItem.inputFarmTraderOrganicInformation.map((farmItem: any) => ({
            tcProductRawMaterialOrder: farmItem.inputFarmTraderOrganicInformationOrder,
            inputFarmSCNo: farmItem.inputFarmScNo,
            inputFarmTCNo: farmItem.inputFarmTcNo,
            inputTraderTCNoForOrganicMaterial: farmItem.inputTraderTcNoForOrganicMaterial,
            inputTCOrganicFarmStandards: farmItem.inputTcOrganicFarmStandards,
        })),
        inputTcProductNo: inputItem.inputTcProductInformation[0]?.inputTcProductNo,
        inputTcProductArticleNo: inputItem.inputTcProductInformation[0]?.inputTcProductArticleNo,
        inputTcProductNumberOfUnits: inputItem.inputTcProductInformation[0]?.inputTcProductNumberOfUnits,
        inputTcProductUnitsMetric: inputItem.inputTcProductInformation[0]?.inputTcProductUnitsMetric,
        inputTcProductProductionDate: inputItem.inputTcProductInformation[0]?.inputTcProductProductionDate,
        inputTcProductCategoryCode: inputItem.inputTcProductInformation[0]?.inputTcProductCategoryCode,
        inputTcProductCategoryUserSpecificTerm: inputItem.inputTcProductInformation[0]?.inputTcProductCategoryUserSpecificTerm,
        inputTcProductDetailCode: inputItem.inputTcProductInformation[0]?.inputTcProductDetailCode,
        inputTcProductDetailUserSpecificTerm: inputItem.inputTcProductInformation[0]?.inputTcProductDetailUserSpecificTerm,
        inputTcProductInfoTrimsExcluded: inputItem.inputTcProductInformation[0]?.inputTcProductInfoTrimsExcluded,
        inputTcProductInfoAssociatedTc: inputItem.inputTcProductInformation[0]?.inputTcProductInfoAssociatedTc,
        inputTcProductInfoFiberLength: inputItem.inputTcProductInformation[0]?.inputTcProductInfoFiberLength,
        inputTcProductInfoYarnCount: inputItem.inputTcProductInformation[0]?.inputTcProductInfoYarnCount,
        inputTcProductInfoFabricWeightAndConstruct: inputItem.inputTcProductInformation[0]?.inputTcProductInfoFabricWeightAndConstruct,
        inputTcProductInfoFabricWeightOfFinishedProduct: inputItem.inputTcProductInformation[0]?.inputTcProductInfoFabricWeightOfFinishedProduct,
        inputTcProductInfoAdditional: inputItem.inputTcProductInformation[0]?.inputTcProductInfoAdditional,
        "tc-std-info": inputItem.inputTcProductInformation[0]?.inputTcProductStandardInformation.map((stdItem: any) => ({
            standardLabelGrade: stdItem.inputTcProductStandardLabelGrade,
            certifiedWeight: stdItem.inputTcProductCertifiedWeight,
            certifiedWeightUsed: stdItem.inputTcProductCertifiedWeightUsed,
        })),
        "raw-materials-info": inputItem.inputTcProductInformation[0]?.inputProductRawMaterialInformation.map((rawItem: any) => ({
            tcProductRawMaterialOrder: rawItem.inputProductRawMaterialInformationOrder,
            tcProductRawMaterialCode: rawItem.inputTcProductRawMaterialCode,
            tcProductRawMaterialPercentage: rawItem.inputTcProductRawMaterialPercentage,
        })),
    }));

    return { tcId, data };
};
